import { useState, Ref, ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import Collapse from 'react-bootstrap/Collapse';



interface CollapsedBlockProps {
	label: string,
	element: ReactNode,
	openOnInit?: boolean,
	isDisabled?: boolean,
	ref?: Ref<HTMLDivElement | null>,
}


export const CollapsedBlock = (props: CollapsedBlockProps) => {
	const { label, element, openOnInit = true, isDisabled, ref } = props;

	const [ open, setOpen ] = useState(openOnInit);

	return (
		<div className="component-collapsed-block" ref={ref}>
			
			<div className='block-label' onClick={() => setOpen(!open)}>
				
				<div className={`block-icon${!isDisabled && open ? ' block-open' : ' block-close'}`}>
					<FontAwesomeIcon icon={faChevronRight} />
				</div>

				<p>{label}</p>

			</div>


			<Collapse in={isDisabled ? false : open}>
				<div className="detail-collapsed-content">
					{element}
				</div>
			</Collapse>
		
		</div>
	)
}

export default CollapsedBlock;